import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  MailIcon,
  PhoneIcon,
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  XIcon,
} from 'lucide-react';
import './css/UpperNav.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const UpperNav = () => {
  const [phoneNumber, setPhoneNumber] = useState('+966573394229');
  const [supportEmail, setSupportEmail] = useState('info@nabdh-ksa.com');
  const [facebookUrl, setFacebookUrl] = useState('https://www.facebook.com/');
  const [instagramUrl, setInstagramUrl] = useState('https://www.instagram.com/');
  const [linkedinUrl, setLinkedinUrl] = useState('https://www.linkedin.com/');
  const [xUrl, setXUrl] = useState('https://x.com/');

  useEffect(() => {
    const fetchUpperNav = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/upper-nav`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.settings) {
          if (data.settings.phoneNumber) setPhoneNumber(data.settings.phoneNumber);
          if (data.settings.supportEmail) setSupportEmail(data.settings.supportEmail);
          if (data.settings.facebookUrl) setFacebookUrl(data.settings.facebookUrl);
          if (data.settings.instagramUrl) setInstagramUrl(data.settings.instagramUrl);
          if (data.settings.linkedinUrl) setLinkedinUrl(data.settings.linkedinUrl);
          if (data.settings.xUrl) setXUrl(data.settings.xUrl);
        }
      } catch {
        // fall back to defaults on error
      }
    };

    fetchUpperNav();
  }, []);

  return (
    <section className="upper-nav">
      <div className="container">
        <div className="upper-nav-content">
          <div className="contact-info">
            <Link to={`mailto:${supportEmail}`}>
              <MailIcon className="icon" />
              {supportEmail}
            </Link>
            <Link to={`tel:${phoneNumber}`}>
              <PhoneIcon className="icon" />
              {phoneNumber}
            </Link>
          </div>

          <div className="social-links">
            <Link to={facebookUrl}>
              <FacebookIcon className="icon" />
            </Link>
            <Link to={instagramUrl}>
              <InstagramIcon className="icon" />
            </Link>
            <Link to={linkedinUrl}>
              <LinkedinIcon className="icon" />
            </Link>
            <Link to={xUrl}>
              <XIcon className="icon" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpperNav;